export const richText = {
  allowedTags: [
    'a', 'b', 'blockquote', 'br', 'button', 'caption', 'cite', 'code', 'div', 'em', 'figcaption', 'figure', 'h2',
    'h3', 'h4', 'h5', 'h6', 'hr', 'i', 'iframe', 'img', 'li', 'link', 'nl', 'ol', 'p', 'pre',
    'script', 'span', 'strike', 'strong', 'style', 'table', 'tbody', 'td', 'th', 'thead', 'tr',
    'ul', 'sup', 'sub',
  ],
  allowedAttributes: {
    '*': ['class', 'data-*'],
    a: ['href', 'name', 'target', 'rel'],
    iframe: ['*'],
    img: ['src', 'srcset', 'width', 'height', 'alt'],
    script: ['type', 'src'],
    link: ['href', 'rel', 'type'],
    span: ['style'],
  },
  selfClosing: ['img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta'],
  allowedSchemes: ['http', 'https', 'ftp', 'mailto'],
  allowedSchemesByTag: {},
  allowProtocolRelative: true,
  allowVulnerableTags: true,
};

export const plainText = {
  allowedTags: ['a', 'b', 'i', 'strong', 'em', 'span'],
  allowedAttributes: {
    a: ['href', 'name', 'target'],
  },
};

export const plainTextNoHTML = {
  allowedTags: [],
  allowedAttributes: [],
};
